import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../features/auth/authSelectors";

function ProtectedRoute() {
  const isAuthed = useSelector(selectIsAuthenticated);
  if (!isAuthed) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export default ProtectedRoute;

